<template>
    <div>
        <div class="modal fade" id="proposalSignerModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Select signer order</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <draggable v-model="signerOrder" @change="changeSignerOrder()">
                            <transition-group>
                                <div v-for="(signer, index) in signerOrder" :key="'dragable-'+signer.id" class="d-block border-1 border-grey-light mb-3 rounded" :id="signer.id" draggable="true">
                                    <div class="row overflow-hidden p-0 m-0">
                                        <div class="col-1 p-0 m-0 bg-grey-light d-flex align-items-center justify-content-center cursor-move">
                                            <i class="fa fa-bars text-sm" aria-hidden="true"></i>
                                        </div>
                                        <div class="col-11 px-3 bg-white rounded py-2">
                                            <div class="row mb-2">
                                                <div class="col-12">
                                                    <span class="mr-2 font-weight-bold">{{signer.name}}</span> <span class="text-grey-darkest float-right text-sm">(Recipient {{index+1}})</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <input readonly type="email" :value="signer.email" class="form-control text-black text-sm">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </transition-group>
                        </draggable>
                    </div>
                    <div class="modal-footer d-block text-right">
                        <i class="fa fa-info-circle proposal-signer-info float-left mt-3 text-xl text-teal cursor-pointer" aria-hidden="true" title="Drag and drop to change the proposal recipient order"></i>
                        <button type="button" class="btn btn-outline-primary rounded-full btn-sm" v-if="buttonFor === 'sign'" @click="userSelection('sign')">Send to Client for Signing</button>
                        <button type="button" class="btn btn-outline-primary rounded-full btn-sm" v-if="buttonFor === 'copy'" @click="userSelection('copy')">Copy Signing Link</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
    name: 'proposal-signer',
    props: ['signerOptions', 'proposalId'],
    components: {draggable},
    data() {
        return {
            signerOrder: this.signerOptions,
            buttonFor: null
        }
    },
    created(){

    },
    mounted() {

    },
    methods: {
        openProposalSignerModal(){
            $('#proposalSignerModal').modal('show');
            this.$nextTick(() => {
               $('.proposal-signer-info').tooltip();
            });
        },
        changeSignerOrder(){
            this.$nextTick(() => {
                axios.post(route('proposal-generator.signing-fields-change-order'), {signerFields: this.signerOrder, proposalId: this.proposalId}).then((response) => {
                    this.signerOrder = response.data.signerData;
                });
            });
        },
        userSelection(userSelection){
            if(userSelection == 'sign'){
                this.$parent.sendForSigning();
            }else if(userSelection == 'copy'){
                this.$parent.copySigningLink();
            }
            this.changeSignerOrder();
            $('#proposalSignerModal').modal('hide');
        }
    }
}
</script>
